import { Box, Button, Flex, theme } from '@/components';
import { ArrowLeftOutlined, CloseOutlined } from '@ant-design/icons';
import type { CSSProperties, FC, ReactNode } from 'react';

type Props = {
  height?: CSSProperties['height'];
  canBack?: boolean;
  onBack: () => void;
  extra?: ReactNode;
};

export const SiderHeader: FC<Props> = ({ height, canBack, onBack, extra }) => {
  const { token } = theme.useToken();
  const borderStyle = `1px solid ${token.colorFill}`;
  return (
    <Box
      position="sticky"
      boxSizing="border-box"
      width="100%"
      top={0}
      zIndex={10}
      padding="16px 24px"
      borderBottom={borderStyle}
      background={token.colorBgBase}
      height={height}
    >
      <Flex justify="space-between" align="center">
        <Box
          height={32}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Button
            onClick={onBack}
            type="text"
            icon={canBack ? <ArrowLeftOutlined /> : <CloseOutlined />}
            size="small"
          />
        </Box>
        {extra}
      </Flex>
    </Box>
  );
};
